import { throwInternalError, throwParseError } from "@arktype/util";
import { writeUnexpectedCharacterMessage } from "./shift/operator/operator.js";
export const fullStringParse = (s) => {
    s.parseOperand();
    const result = parseUntilFinalizer(s).root;
    if (!result) {
        return throwInternalError(`Root was unexpectedly unset after parsing string '${s.scanner.scanned}'`);
    }
    s.scanner.shiftUntilNonWhitespace();
    if (s.scanner.lookahead) {
        // throw a parse error if non-whitespace characters made it here without being parsed
        throwParseError(writeUnexpectedCharacterMessage(s.scanner.lookahead));
    }
    return result;
};
export const parseUntilFinalizer = (s) => {
    while (s.finalizer === undefined)
        next(s);
    return s;
};
const next = (s) => s.hasRoot() ? s.parseOperator() : s.parseOperand();
